<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">图片审核</h3>
                </div>
                <el-button type="primary" :disabled="!canEditPage" @click="openManualCheck">手动检测</el-button>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
              <el-form :inline="true" class="task-image-audit-filters" @submit.prevent="search">
                <el-form-item label="活动 ID">
                  <el-input v-model="filters.task_id" clearable placeholder="请输入活动 ID" style="width: 220px" />
                </el-form-item>
                <el-form-item label="UnionID">
                  <el-input v-model="filters.unionid" clearable placeholder="请输入 UnionID" style="width: 220px" />
                </el-form-item>
                <el-form-item label="检测结果">
                  <el-select v-model="filters.violation" clearable style="width: 130px">
                    <el-option label="全部" value="" />
                    <el-option label="待判定" value="pending" />
                    <el-option label="违规" value="true" />
                    <el-option label="PASS" value="false" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="filters.onlyHasQrcode">只看有二维码</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button @click="resetFilters">重置</el-button>
                </el-form-item>
              </el-form>
              <div class="block w-full overflow-x-auto">
                <el-table :data="records" v-loading="loading" border stripe style="width: 100%; min-width: 1200px;">
      <el-table-column label="图片" width="110">
        <template #default="{ row }">
          <el-image
            :src="row.image_url"
            fit="cover"
            style="width:72px;height:72px;cursor:pointer"
            @click="previewImage(row.image_url)"
          />
        </template>
      </el-table-column>
      <el-table-column label="活动 ID / UnionID" min-width="220">
        <template #default="{ row }">
          <div class="break-all">{{ row.task_id || "-" }}</div>
          <div class="mt-1 break-all text-xs text-gray-500">{{ row.unionid || "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="来源 / 资源 ID" min-width="200">
        <template #default="{ row }">
          <div>{{ sourceLabel(row) }}</div>
          <div class="mt-1 break-all text-xs text-gray-500">{{ row.resource_id || row.source_path || "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="source_path" label="配置位置" min-width="180" />
      <el-table-column label="二维码内容" min-width="260">
        <template #default="{ row }">
          <div v-if="qrcodeContents(row).length">
            <div v-for="(content, index) in qrcodeContents(row)" :key="qrcodeContentKey(row, index)" class="mb-2 last:mb-0">
              <span class="break-all">{{ truncatedQrcodeContent(row, content, index) }}</span>
              <el-button v-if="needsExpansion(content)" link type="primary" class="ml-1" @click="toggleQrcodeContent(row, index)">
                {{ isQrcodeContentExpanded(row, index) ? "收起" : "展开" }}
              </el-button>
            </div>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="检测结果" width="120">
        <template #default="{ row }">
          <el-tag v-if="isPass(row)" type="success" effect="light">PASS</el-tag>
          <span v-else>{{ violationLabel(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="{ row }">
          <el-button v-if="!isViolation(row)" link type="danger" @click="review(row, true)">标记违规</el-button>
          <el-button v-if="!isPass(row)" link type="success" @click="review(row, false)">标记不违规</el-button>
        </template>
      </el-table-column>
                </el-table>
              </div>
              <el-pagination class="mt-4" layout="total, prev, pager, next" :total="total" :page-size="pageSize" @current-change="changePage" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="previewVisible" title="图片预览" top="5vh" width="720px" destroy-on-close>
      <div class="task-image-audit-preview">
        <img v-if="previewUrl" :src="previewUrl" class="task-image-audit-preview__image" />
      </div>
    </el-dialog>
    <el-dialog v-model="manualCheckVisible" title="手动检测活动图片" width="760px" top="5vh">
      <el-form @submit.prevent="runManualCheck">
        <el-form-item label="活动 ID" required>
          <el-input v-model="manualTaskId" clearable placeholder="请输入活动 ID" :disabled="manualCheckLoading" />
        </el-form-item>
      </el-form>
      <div v-if="manualCheckResults !== null" class="task-image-audit-manual-results">
        <div class="mb-3">共提交 {{ manualCheckResults.length }} 张图片进行异步检测</div>
        <el-empty v-if="!manualCheckResults.length" description="活动中没有需要检测的图片" />
        <div v-for="item in manualCheckResults" :key="item.url" class="task-image-audit-manual-item">
          <el-image :src="item.url" fit="cover" style="width: 72px; height: 72px; flex: none" :preview-src-list="[item.url]" />
          <div class="min-w-0 flex-1">
            <div class="break-all">{{ item.url }}</div>
            <div class="text-xs text-gray-500 break-all">{{ item.source_path }}</div>
            <el-tag :type="item.result && item.result.sta === 0 ? 'success' : 'danger'" size="small" class="mt-2">
              {{ item.result && item.result.sta === 0 ? '已提交' : '提交失败' }}
            </el-tag>
            <pre class="task-image-audit-manual-response">{{ formatCheckResult(item.result) }}</pre>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="manualCheckVisible = false">关闭</el-button>
        <el-button type="primary" :loading="manualCheckLoading" @click="runManualCheck">开始检测</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { luckdrawApi } from "@/api/luckdraw";
import taskImageAudit from "@/utils/task-image-audit";
import { getUserInfo } from "@/utils/auth.js";
import { MENU_PERMISSION_KEYS, canEdit } from "@/utils/rbac.js";
export default {
  data() { return { filters: { task_id: "", unionid: "", violation: "pending", onlyHasQrcode: true }, records: [], total: 0, page: 1, pageSize: 20, loading: false, isResettingFilters: false, expandedQrcodeContents: {}, previewVisible: false, previewUrl: "", manualCheckVisible: false, manualTaskId: "", manualCheckLoading: false, manualCheckResults: null }; },
  computed: {
    canEditPage() { return canEdit(getUserInfo(), MENU_PERMISSION_KEYS.MONITOR_IMAGE_AUDIT); },
  },
  mounted() { this.loadRecords(); },
  watch: {
    "filters.violation"() { this.autoSearch(); },
    "filters.onlyHasQrcode"() { this.autoSearch(); },
  },
  methods: {
    violationLabel(row) { return row.is_violation === true ? "违规" : row.is_violation === false ? "PASS" : "待判定"; },
    isPass(row) { return taskImageAudit.isPass(row); },
    isViolation(row) { return taskImageAudit.isViolation(row); },
    sourceLabel(row) { return row.reference_type === "resource" ? "二维码素材库" : "活动配置"; },
    qrcodeContents(row) { return taskImageAudit.getQrcodeContents(row); },
    qrcodeContentKey(row, index) { return `${row._id}-${index}`; },
    isQrcodeContentExpanded(row, index) { return Boolean(this.expandedQrcodeContents[this.qrcodeContentKey(row, index)]); },
    truncatedQrcodeContent(row, content, index) { return taskImageAudit.truncateQrcodeContent(content, this.isQrcodeContentExpanded(row, index)); },
    needsExpansion(content) { return taskImageAudit.needsQrcodeExpansion(content); },
    toggleQrcodeContent(row, index) { const key = this.qrcodeContentKey(row, index); this.expandedQrcodeContents[key] = !this.expandedQrcodeContents[key]; },
    previewImage(url) { this.previewUrl = url; this.previewVisible = true; },
    openManualCheck() {
      this.manualTaskId = this.filters.task_id || "";
      this.manualCheckResults = null;
      this.manualCheckVisible = true;
    },
    formatCheckResult(result) { return JSON.stringify(result, null, 2); },
    async runManualCheck() {
      const taskId = this.manualTaskId.trim();
      if (!taskId) { this.$message.warning("请输入活动 ID"); return; }
      if (this.manualCheckLoading) return;
      this.manualCheckLoading = true;
      this.manualCheckResults = null;
      try {
        const response = await luckdrawApi.manualCheckTaskImages({ task_id: taskId });
        if (response.sta !== 0) { this.$message.error(response.msg || "检测失败"); return; }
        this.manualCheckResults = response.data.results || [];
      } catch (error) {
        this.$message.error(error.message || "检测失败");
      } finally {
        this.manualCheckLoading = false;
      }
    },
    search() { this.page = 1; this.loadRecords(); },
    autoSearch() { if (!this.isResettingFilters) this.search(); },
    resetFilters() {
      this.isResettingFilters = true;
      this.filters = { task_id: "", unionid: "", violation: "pending", onlyHasQrcode: true };
      this.$nextTick(() => { this.isResettingFilters = false; this.search(); });
    },
    async loadRecords() { this.loading = true; try { const result = await luckdrawApi.getTaskImageAuditList(taskImageAudit.buildTaskImageAuditListParams(this.filters, this.page, this.pageSize)); if (result.sta === 0) { this.records = result.data.list; this.total = result.data.total; } } finally { this.loading = false; } },
    changePage(page) { this.page = page; this.loadRecords(); },
    async review(row, isViolation) {
      const resultLabel = isViolation ? "违规" : "PASS";
      try {
        await this.$confirm(`确定将该图片标记为 ${resultLabel} 吗？本次操作将记录当前操作人。`, "操作确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (_error) {
        return;
      }
      const result = await luckdrawApi.reviewTaskImageAudit({ id: row._id, is_violation: isViolation });
      if (result.sta === 0) { this.$message.success("已更新"); this.loadRecords(); }
    },
  },
};
</script>

<style scoped>
.task-image-audit-filters {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 0 16px;
  margin-bottom: 20px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.task-image-audit-filters :deep(.el-form-item) {
  flex: 0 0 auto;
  margin-bottom: 0;
  margin-right: 0;
}

.task-image-audit-preview {
  display: flex;
  justify-content: center;
}

.task-image-audit-preview__image {
  max-height: calc(95vh - 120px);
  max-width: 100%;
  object-fit: contain;
}

.task-image-audit-manual-results {
  max-height: 55vh;
  overflow-y: auto;
}

.task-image-audit-manual-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #e5e7eb;
}

.task-image-audit-manual-response {
  margin-top: 8px;
  padding: 8px;
  overflow-x: auto;
  background: #f8fafc;
  font-size: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
